<template>
<div style="margin-top: 12px">
  <SOMenuItemIcon
    title="Stiker QRIS"
    :icon-qr="true"
    :show-subtitle="true"
    subtitle="Untuk ditempel di mesin"
      @action="$emit('qr')"
  />
  <SOMenuItemIcon
      :icon-edit="true"
      title="Ubah Data Mesin"
      @action="toEdit"
      v-if="validateAccess('snapBridge.update')"
  />
  <SOMenuItemIcon
      style="margin-top: 12px"
      title="Hapus Mesin"
      :icon-trash="true"
      :is-trash-red="true"
      @action="$emit('hapus')"
      v-if="validateAccess('snapBridge.delete')"
  />
</div>
</template>

<script>
import SOMenuItemIcon from "@/so-components/global/ui/SOMenuItemIcon";
export default {
  name: "SOActionBottom",
  components: {SOMenuItemIcon},
  props: {
    idMesin: String,
    idOutlet: String
  },
  methods: {
    toEdit(){
      this.$router.push({
        name: "SnapMesinEdit",
        params: {
          idmesin: this.idMesin
        },
        query: {
          idoutlet: this.idOutlet,
          from: "detail"
        }
      })
    }
  }
}
</script>

<style scoped>

</style>